'use client';
import React, { useState } from 'react';
import Image from 'next/image';

const People = ({ people }) => {
  const [selectedPerson, setSelectedPerson] = useState(null);

  const handleSelectPerson = (person) => {
    setSelectedPerson(selectedPerson === person ? null : person);
  };

  return (
    <section className="py-20 bg-gray-100">
      <div className="max-w-screen-lg mx-auto text-center">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 p-6">
          {people.map((person, index) => (
            <div
              key={index}
              className="cursor-pointer"
              onClick={() => handleSelectPerson(person)}
            >
              <Image
                className="rounded-lg shadow-md"
                src={person.image}
                alt={person.name}
                width={300}
                height={300}
              />
              <h3 className="text-xl font-semibold mb-0 mt-2">{person.name}</h3>
              <p className="font-medium text-black">{person.position}</p>
            </div>
          ))}
        </div>

        {selectedPerson && (
          <div className="max-w-3xl mx-auto mt-10 bg-white p-8 rounded-lg shadow-md">
            <h2 className="text-4xl text-gray-900">{selectedPerson.name}</h2>
            <h3 className="text-base text-gray-900">
              {selectedPerson.position}
            </h3>
            <Image
              className="rounded-lg shadow-md my-4 text-center mx-auto"
              src={selectedPerson.image}
              alt={selectedPerson.name}
              width={300}
              height={200}
            />
            <p className="text-gray-600">{selectedPerson.description}</p>
            {selectedPerson.moreDescription && (
              <div>
                <p className="mt-4 text-gray-600">
                  {selectedPerson.moreDescription}
                </p>
              </div>
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default People;
